<template>
  <v-dialog max-width="1200px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;padding:0;">
        <v-layout row>
          <v-flex xs6>
            <v-tabs dark v-model="tabs" grow>
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
            </v-tabs>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-select :items="store_item" item-text="name" label="Store"></v-select>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-select :items="product_type_item" item-text="name" label="Product type"></v-select>
                  </v-flex>
                </v-layout>
                <v-tabs-items v-model="tabs">
                  <v-tab-item v-for="n in 3" :key="n">
                    <div style="padding-top:1px;">
                      <v-text-field v-model="product_name" label="Product name" :rules="product_name?[rules.max]:[]"></v-text-field>
                      <v-textarea name="description" label="Description" value rows="1" :rules="[rules.max_description]"></v-textarea>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
                <v-layout row class="py-2">
                  <v-flex xs2 class="mr-2" style="position:relative;">
                    <label style="font-size:17px;position:absolute;top:5px;color:#616A6B;">Other :</label>
                  </v-flex>
                  <v-flex xs10 class="ml-2">
                    <v-layout row justify-space-around>
                      <v-flex xs5>
                        <v-checkbox
                          label="Recommend"
                          color="primary"
                          value="1"
                          hide-details
                          style="margin:0;"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs5>
                        <v-checkbox
                          label="Best Seller"
                          color="primary"
                          value="2"
                          hide-details
                          style="margin:0;"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field v-model="sale_price" label="Sale price"></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field v-model="base_price" label="Base price"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-select :items="product_status" item-text="name" label="Product status"></v-select>

                <v-layout row>
                  <v-flex xs3 style="position:relative;">
                    <label
                      style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                    >Uplode Image :</label>
                  </v-flex>
                  <v-flex xs9 class="ml-2">
                    <v-btn>Choose Files</v-btn>
                    <span class="ml-2">123.jpg</span>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>

            <!-- <v-card-actions style="background-color:green;">
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click="$emit('setDialog', false)">Cancel</v-btn>
                    <v-btn color="green" flat>Save</v-btn>
            </v-card-actions>-->
          </v-flex>
          <v-flex xs6>
            <v-toolbar dense flat color="transparent">
              <v-toolbar-title>Option List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn round small color="primary" class="black--text">
                <v-icon>add</v-icon>add option
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <newOptionForm/>
              <optionDetail/>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <!-- <v-layout row>
            <v-flex xs6 class="text-xs-right">
                <v-btn color="red" flat @click="$emit('setDialog', false)">Cancel</v-btn>
                <v-btn color="green" flat>Save</v-btn>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
                <v-btn color="red" flat @click="$emit('setDialog', false)">Cancel</v-btn>
                <v-btn color="green" flat>Save</v-btn>
            </v-flex>
        </v-layout>-->
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat
          @click="$emit('setDialog', false) && $emit('setEditIndex',-1)"
        >Cancel</v-btn>
        <v-btn color="green" flat>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import newOptionForm from "./NewOptionForm";
import optionDetail from "./OptionDetail";
export default {
  props: ["dialog", "editedIndex"],
  data() {
    return {
      valid: true,
      rules: {
      max: value => value.length <= 55 || "Maximum length is 55 characters.",
      max_description: value => value.length <= 255 || "Maximum length is 255 characters."
      },
      store_item: [
        {
          name: "กล้วยน้ำว้า",
          value: 1
        }
      ],
      product_type_item: [
        {
          name: "อาหารไทย",
          value: 1
        },
        {
          name: "อาหารจานเดียว",
          value: 2
        }
      ],
      product_status: [
        {
          name: "Active",
          value: 1
        },
        {
          name: "Inactive",
          value: 2
        }
      ],
      product_name: "",
      base_price: "",
      sale_price: "",
      tabs: null,
      lang: ["TH", "EN", "CN"]
    };
  },
  components: {
    newOptionForm,
    optionDetail
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    }
  }
};
</script>



